const teachers = {
  pageTitle: 'المعلمين',
  // Table columns
  number: '#',
  teacher: 'المعلم',
  role: 'الدور',
  class: 'الفصل',
  students: 'الطلاب',
  joiningDate: 'تاريخ الانضمام',
  contact: 'الاتصال',
  status: 'الحالة',
  // Status
  active: 'نشط',
  onLeave: 'في إجازة',
  inactive: 'غير نشط',
  // Filters
  searchTeachers: 'البحث عن معلمين...',
  allClasses: 'جميع الفصول',
  allRoles: 'جميع الأدوار',
  filtered: 'مُصفى',
  // Onboarding modal
  step1Label: 'الملف الشخصي',
  step2Label: 'التعيين',
  step1Title: 'الملف الشخصي للمعلم',
  step2Title: 'تفاصيل الفصل والتعيين',
  onboardTeacher: 'إضافة معلم',
  enterFullName: 'أدخل الاسم الكامل للمعلم',
  selectRole: 'اختر الدور',
  fullResidentialAddress: 'العنوان السكني الكامل',
  selectClassSection: 'اختر الفصل / القسم',
  profileSummary: 'ملخص الملف الشخصي',
  assignmentSummaryPrefix: 'معين إلى',
  joiningPrefix: 'تاريخ الانضمام',
  completeFieldsPrompt: 'أكمل الحقول أعلاه لرؤية ملخص التعيين.',
  // Detail modal
  editTeacher: 'تعديل المعلم',
  profileInformation: 'معلومات الملف الشخصي',
  assignmentDetails: 'تفاصيل التعيين',
  studentsAssigned: '{{count}} طالب معين',
  studentsAssignedPlural: '{{count}} طلاب معينين',
  teacherHasStudents: 'هذا المعلم لديه {{count}} طالب في {{className}}',
  teacherHasStudentsPlural: 'هذا المعلم لديه {{count}} طلاب في {{className}}',
  viewStudents: 'عرض الطلاب',
  noStudentsEnrolled: 'لا يوجد طلاب مسجلين بعد',
  saveChanges: 'حفظ التغييرات',
  deactivate: 'تعطيل',
  // Reactivation
  reactivateTeacher: 'إعادة تنشيط المعلم',
  reactivateConfirm: 'إعادة تنشيط {{name}}؟',
  // Empty state
  noTeachersFound: 'لم يتم العثور على معلمين',
};

export default teachers;